import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FlatButton, Dialog } from 'material-ui';

import { deleteDomain, getListDomain } from 'actions/domains';

class DeleteDomain extends React.Component {
    render() {
        const { toggle, isOpen, deleteDomain, getListDomain, id } = this.props;

        const actions = [
            <FlatButton
                label='Delete'
                secondary
                onClick={() => {
                    deleteDomain({ id });
                    getListDomain();
                    toggle();
                }}
            />,
            <FlatButton
                label='Cancel'
                primary
                onClick={toggle}
            />,
        ];

        return (
            <Dialog
                title='Do you really want to delete domain?'
                actions={actions}
                modal={false}
                open={isOpen}
                onRequestClose={this.toggle}
            />
        );
    }
}

export default connect(
    () => { return { } },
    dispatch => bindActionCreators({ deleteDomain, getListDomain }, dispatch),
)(DeleteDomain);



// WEBPACK FOOTER //
// ./app/components/Domains/Delete.jsx